module.exports = __webpack_public_path__ + "media/images/lb/445-16636a2916ffebbe91b1cf761f076978.svg";